'use client';

import { FC } from 'react';
import { Button, ButtonProps } from './button';
import classNames from 'classnames';
export type ButtonGroupOption = {
  label: string;
  value: string;
  className?: string;
  disabled?: boolean;
};
type ButtonGroupProps = Omit<ButtonProps, 'className' | 'onChange'> & {
  className?: string;
  activeButtonClassName?: string;
  options: ButtonGroupOption[];
  selectedVariant?: ButtonProps['variant'];
} & ({
  mutable?: false;
  value: string;
  onChange: (value: string) => void;
} | {
  mutable: true;
  value?: string;
  onChange: (value?: string) => void;
});
export const ButtonGroup: FC<ButtonGroupProps> = ({
  className,
  options,
  value,
  variant = 'outline',
  selectedVariant = 'default',
  activeButtonClassName = '',
  disabled,
  mutable,
  onChange,
  ...restProps
}) => {
  return <div className={classNames('flex items-center', className)} data-sentry-component="ButtonGroup" data-sentry-source-file="button-group.tsx">
      {options.map((option, index) => <Button key={option.value} {...restProps} className={classNames('hover:z-10', option.className, option.value === value ? activeButtonClassName : '', {
      'rounded-r-none': index < options.length - 1,
      'rounded-l-none': index > 0
    })} disabled={option.disabled || disabled} variant={option.value === value ? selectedVariant : variant} type="button" onClick={() => {
      if (mutable && option.value === value) {
        onChange(undefined);
      } else {
        onChange(option.value);
      }
    }}>
          {option.label}
        </Button>)}
    </div>;
};